
export const ThinChevronLeft = ({
  className,
  style,
  onClick,
  size = 50,
  color = "#000000",
  strokeWidth = 0.18,
}) => (
   <div className={className} style={{ ...style }} onClick={onClick}>
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M15 5 L7 12 L15 19"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    </svg>
    </div>
);

export const ThinChevronRight = ({ className, style, onClick, size = 50, color = "#000", strokeWidth = 0.18 }) => (
  <div className={className} style={{ ...style }} onClick={onClick}>
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path
      d="M8 5 L16 12 L8 19"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
   </div>
);
